/*
 *
 * App reducer
 *
 */
import produce from 'immer';
import { LOGIN_USER_SUCCESS } from 'ui/containers/LoginPage/constants';
import {
  CHANGE_CURRENT_PROJECT_SUCCESS,
  GET_TEAMS_ONLY_TOKEN,
  GET_APP_DETAILS,
  SEND_UPGRADE_MAIL,
} from './constants';

export const initialState = {
  loading: false,
  error: false,
  user: {
    token: false,
    isAuthenticated: false, // check if user has token
  },
  currentProject: {
    projectName: null,
  },
  appDetails: {
    loading: true,
    data: {},
    error: false,
  },
  upgradeMail: {
    loading: false,
    error: false,
  },
};

/* eslint-disable default-case, no-param-reassign */
const appReducer = (state = initialState, action) => {
  const data = action.payload && action.payload.data;

  return produce(state, draft => {
    switch (action.type) {
      case SEND_UPGRADE_MAIL.START:
        draft.upgradeMail.loading = true;
        break;
      case SEND_UPGRADE_MAIL.SUCCESS:
        draft.upgradeMail.loading = false;
        break;
      case SEND_UPGRADE_MAIL.ERROR:
        draft.upgradeMail.loading = false;
        break;
      case GET_APP_DETAILS.START:
        draft.appDetails.loading = true;
        break;
      case GET_APP_DETAILS.SUCCESS:
        draft.appDetails.loading = false;
        break;
      case GET_APP_DETAILS.ERROR:
        draft.appDetails.error = true;
        break;
      case LOGIN_USER_SUCCESS:
        draft.user.token = data && data.token;
        draft.user.isAuthenticated = data && !!data.token;
        break;
      case CHANGE_CURRENT_PROJECT_SUCCESS:
        draft.currentProject.projectName = data && data.name;
        break;
      case GET_TEAMS_ONLY_TOKEN.START:
        draft.loading = true;
        draft.error = false;
        break;
      case GET_TEAMS_ONLY_TOKEN.SUCCESS:
        draft.user.token = data && data.token;
        draft.user.isAuthenticated = data && !!data.token;
        draft.loading = false;
        draft.error = false;
        break;
      case GET_TEAMS_ONLY_TOKEN.ERROR:
        draft.loading = false;
        draft.error = true;
        break;
    }
  });
};

export default appReducer;
